<script>
   /*************************************************************/
   /* ModelLoader                                               */
   /* -------------------------                                 */
   /* loads preprocessing model from file                       */
   /*************************************************************/

   import { FileSelector, Container, Button } from 'svelte-controls-basic';
   import { reviver } from '../../utils.js';
   import { checkPrepModel } from '../../methods/prep.js';
    import ModelInfo from './ModelInfo.svelte';

   let {
      model = $bindable()
   } = $props();    // object with model


   // the picked file and its name without the extension
   let modelFile = $state('');
   const modelFileName = $derived(modelFile ? modelFile.name.replace(/\.[^/.]+$/, "") : '');

   // message of a failed attempt; a status kept next to it said nothing the message did not
   let errMsg = $state('');

   // gets model content as one large string, parse it into matrix
   function setModel(strData) {
      try{
         const m = JSON.parse(strData, reviver);

         // the checks live in 'methods/prep.js': prep's session check runs the same ones on a
         // restored model, which used to reach the info panel unchecked
         checkPrepModel(m);
         m['fileName'] = modelFileName;
         model = m;
         errMsg = ''
      } catch (e) {
         console.log(e);
         // 'model' is left as it is: the picker, and with it this function, is only shown while
         // it is falsy. writing null over the session's initial 0 counted as a change, the effect
         // below cleared the picker and the picker's effect then cleared this message, so the
         // first damaged file was refused without a word
         // the message only: the box printed the Error object, which reads 'Error: ...'. a file
         // the parser refuses is named as such, in place of the parser's own text
         errMsg = e instanceof SyntaxError ? 'The file could not be read as JSON.'
            : e instanceof Error ? e.message : String(e);
      }
   }

   // promise for reading the JSON file
   function readFile (e) {
      const reader = new FileReader();
      reader.onload = () => { setModel(reader.result) };

      // without this a file which can not be read at all - moved or made unreadable between being
      // picked and the button being pressed - left the component in its neutral state, so the
      // button appeared to do nothing
      reader.onerror = () => {
         // 'model' is left as it is, see 'setModel'
         errMsg = 'Could not read the file: ' + (reader.error ? reader.error.message : 'unknown error');
      };
      reader.readAsText(modelFile);
   }

   // the null here stays: prep's apply tab drops its data when the model becomes null
   function reset() {
      modelFile = '';
      model = null;
      errMsg = '';
   }

   // any change of the picked file - a new pick, the clear button, the clear the 'model' effect
   // below makes - drops the message of the last attempt
   $effect(() => {
      modelFile;
      errMsg = '';
   });

   $effect(() => {
      if (model === null || model === 0) modelFile = '';
   });

</script>

{#if !model }

   <!-- show if data is not loaded -->
   <Container name="file-selector">
      <FileSelector bind:file={modelFile} acceptType=".json" message="Select file with model"/>
   </Container>

   {#if modelFile}
   <Container name="load-button" label="&nbsp;">
      <Button onclick={readFile} text="Load" />
   </Container>
   {/if}

{:else}
   <!-- dataset is loaded - show info and cancel button -->
   <ModelInfo {model} {reset}/>
{/if}

<!-- error message -->
{#if errMsg}
<Container name="error" status="error">
   <p>{errMsg}</p>
</Container>
{/if}
